import { render, staticRenderFns } from "./ReasonFailure.vue?vue&type=template&id=12b01eb7&scoped=true"
import script from "./ReasonFailure.vue?vue&type=script&lang=js"
export * from "./ReasonFailure.vue?vue&type=script&lang=js"
import style0 from "./ReasonFailure.vue?vue&type=style&index=0&id=12b01eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b01eb7",
  null
  
)

export default component.exports